// import logo from "./logo.svg";
// import "./App.css";
// import React, { Suspense, useEffect, useReducer, useState } from "react";
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import DefaultLayout from "./Layout/DefaultLayout";
// import Login from "./Pages/LoginLayout/LoginFlowForm/Login";
// import LoginLayout from "./Pages/LoginLayout/LoginLayout";
// import LoginRoutes from "./Routes/LoginRoutes";
// import AdminRoutes from "./Routes/AdminRoutes";
// import LoginView from "./Pages/LoginFlowView/LoginView";
// import SideBar from "./Components/SideBar/SideBar";
// import Header from "./Components/Header/Header";
// import AppContext from "./Context/AppContext";
// import AppBreadcrumbs from "./Components/Widgets/BreadCrumbs";
// import SubscriptionSuccess from "./Pages/SubscriptionManagement/SubscriptionSuccess ";

// function App() {
//   const initialprops = {
//     loggedin: false,
//     subscribed: false,
//     loginInfo: {},
//   };
//   var li = sessionStorage.getItem("loggedIn");
//   var logged = JSON.parse(sessionStorage.getItem("loginfo"));
//   var sub = sessionStorage.getItem("subscribed") === "true";

//   useEffect(() => {
//     setUser({
//       type: "onload",
//       loggedin: li != undefined && li != "false",
//       subscribed: sub,
//       loginInfo: logged,
//     });
//   }, []);

//   const reducer = (state, action) => {
//     switch (action.type) {
//       case "login":
//         return {
//           ...state,
//           loggedin: true,
//           subscribed: sessionStorage.getItem("subscribed") === "true",
//           loginInfo: { ...state.loginInfo, ...action.loginInfo },
//         };
//       case "subscribe":
//         return {
//           ...state,
//           subscribed: true,
//         };
//       case "logout":
//         return { loggedin: false, subscribed: false };
//       case "onload":
//         return {
//           ...state,
//           loggedin: action.loggedin,
//           subscribed: action.subscribed,
//           loginInfo: action.loginInfo,
//         };
//       default:
//         return state;
//     }
//   };

//   const [user, dispatch] = useReducer(reducer, initialprops);

//   const setUser = (obj) => {
//     dispatch(obj);
//   };

 

//   return (
//     <AppContext.Provider value={{ user, setUser }}>
//       <div className="App">
//         <Router basename="/">
//           {user.loggedin ? (
//             !user.subscribed ? (
//                  <Suspense fallback={<div>Loading...</div>}>
//       <Routes>
//         {/* ✅ add success route here — before subscription wall */}
//         <Route path="/subscription/success" element={<SubscriptionSuccess />} />
        
//         {/* existing subscription wall */}
//         <Route path="*" element={<LoginLayout data="subscription" />} />
//       </Routes>
//     </Suspense>
//             ) : (
//               <div className="app-layout">
//                 <SideBar className="sidebar" />
//                 <div className="main-sec">
//                   <div className="header-part">
//                     <Header />
//                   </div>
//                   <div className="m-3">
//                     <AppBreadcrumbs />
//                   </div>
//                   <div className="app-content-sec px-3">
//                     <Suspense fallback={<div>Loading...</div>}>
//                       <Routes>
//                         {AdminRoutes.map((route, i) => (
//                           <Route
//                             key={i}
//                             path={route.path}
//                             element={<route.Element />}
//                           />
//                         ))}
//                       </Routes>
//                     </Suspense>
//                   </div>
//                 </div>
//               </div>
//             )
//           ) : (
//             <div className="log-flow">

//               <Suspense fallback={<div>Loading...</div>}>
//                 <Routes>
//                   {LoginRoutes.map((data, i) => (
//                     <Route
//                       key={i}
//                       path={data.path}
//                       name={data.name}
//                       element={<data.Element />}
//                     />
//                   ))}
//                 </Routes>
//               </Suspense>
//             </div>
//           )}
//         </Router>
//       </div>
//     </AppContext.Provider>
//   );
// }

// export default App;

import logo from "./logo.svg";
import "./App.css";
import React, { Suspense, useEffect, useReducer } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LoginLayout from "./Pages/LoginLayout/LoginLayout";
import LoginRoutes from "./Routes/LoginRoutes";
import AdminRoutes from "./Routes/AdminRoutes";
import SideBar from "./Components/SideBar/SideBar";
import Header from "./Components/Header/Header";
import AppContext from "./Context/AppContext";
import AppBreadcrumbs from "./Components/Widgets/BreadCrumbs";

const SubscriptionSuccess = React.lazy(() =>
  import("./Pages/SubscriptionManagement/SubscriptionSuccess ")  // ← remove trailing space
);

function App() {
  const initialprops = { loggedin: false, subscribed: false, loginInfo: {} };

  var li     = localStorage.getItem("loggedIn");
  var logged = JSON.parse(localStorage.getItem("loginfo"));
  var sub    = localStorage.getItem("subscribed") === "true";

  useEffect(() => {
    setUser({
      type: "onload",
      loggedin: li != undefined && li != "false",
      subscribed: sub,
      loginInfo: logged,
    });
  }, []);

  const reducer = (state, action) => {
    switch (action.type) {

case "login": {
  const subscription = action.loginInfo?.existSubscription;

  const isSubscribed =
    subscription !== null &&
    subscription !== undefined &&
    subscription?.status !== "CANCELLED";

  if (isSubscribed) {
    localStorage.setItem("subscribed", "true");
  } else {
    localStorage.removeItem("subscribed");
  }

  return {
    ...state,
    loggedin: true,
    subscribed: isSubscribed,
    loginInfo: {
      ...state.loginInfo,
      ...action.loginInfo,
    },
  };
}

      case "subscribe":
        return { ...state, subscribed: true };

      case "logout":
        return { loggedin: false, subscribed: false };

      case "onload":
        return {
          ...state,
          loggedin: action.loggedin,
          subscribed: action.subscribed,
          loginInfo: action.loginInfo,
        };

      default:
        return state;
    }
  };

  const [user, dispatch] = useReducer(reducer, initialprops);
  const setUser = (obj) => dispatch(obj);

  return (
    <AppContext.Provider value={{ user, setUser }}>
      <div className="App">
        <Router basename="/">
          {user.loggedin ? (
            !user.subscribed ? (
              // ── logged in, not subscribed ──
              <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                  <Route path="/subscription/success" element={<SubscriptionSuccess />} />
                  <Route path="*" element={<LoginLayout data="subscription" />} />
                </Routes>
              </Suspense>
            ) : (
              // ── logged in, subscribed ──
              <div className="app-layout">
                <SideBar className="sidebar" />
                <div className="main-sec">
                  <div className="header-part"><Header /></div>
                  <div className="m-3"><AppBreadcrumbs /></div>
                  <div className="app-content-sec px-3">
                    <Suspense fallback={<div>Loading...</div>}>
                      <Routes>
                        {AdminRoutes.map((route, i) => (
                          <Route key={i} path={route.path} element={<route.Element />} />
                        ))}
                      </Routes>
                    </Suspense>
                  </div>
                </div>
              </div>
            )
          ) : (
            // ── not logged in ──
            <div className="log-flow">
              <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                  {LoginRoutes.map((data, i) => (
                    <Route key={i} path={data.path} name={data.name} element={<data.Element />} />
                  ))}
                </Routes>
              </Suspense>
            </div>
          )}
        </Router>
      </div>
    </AppContext.Provider>
  );
}

export default App;